// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"b74007cc","433":"59a61737"}[chunkId] + ".chunk.css";
};